import React from "react";
import TextBtn from "../Buttons/Text";
import s from "./index.css";

export const CloseBtn = ({ onClick }) => (
  <TextBtn onClick={onClick} className="d-block pt-2 pr-2 ml-auto text-red">
    <p className={s.close}>+</p>
  </TextBtn>
);



// WEBPACK FOOTER //
// ./src/components/Modal/CloseBtn.js